import { DocumentSubtract } from "@carbon/icons-react";
import React, { Dispatch, FunctionComponent, SetStateAction, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { ReportMetadata, ReportStage } from "./ReportModels";
import { useMsal } from "@azure/msal-react";
import ApiHelper from "../Shared/ApiHelper";
import { useParams } from "react-router-dom";
import { Slide, toast } from "react-toastify";

interface ReportUnublishButtonProps {
    reportMetadata: ReportMetadata;
    setReportMetadata: Dispatch<SetStateAction<ReportMetadata | undefined>>;
    createdByUser: boolean;
}

const ReportUnpublishButton: FunctionComponent<ReportUnublishButtonProps> = (props: ReportUnublishButtonProps) => {
    const {reportMetadata, setReportMetadata, createdByUser } = props;
    const [isUnpublishing, setIsUnpublishing] = useState(false);

    const {instance} = useMsal();
    const [api] = useState(new ApiHelper());
    const { reportId } = useParams();

    return reportId !== undefined ? (
        <Button
            disabled={isUnpublishing}
            variant="outline-primary"
            title="Unpublish Report"
            onClick={() => {
                setIsUnpublishing(true);
                api.callApi(
                    instance,
                    [process.env.REACT_APP_B2C_SCOPE ?? ''],
                    process.env.REACT_APP_NET_API_URL + `/PbiReport/${reportId}/unpublish`,
                    'PUT'
                ).then(async (_result: Response) => {
                    setReportMetadata((prevMetadata: ReportMetadata | undefined) => {
                        if (prevMetadata) {
                            return { ...prevMetadata, stage: ReportStage.Private };
                        }
                    });
                    setIsUnpublishing(false);
                    toast.success('Report has been unpublished', {
                        position: 'top-right',
                        autoClose: 5000,
                        transition: Slide,
                        draggable: false,
                        closeOnClick: false,
                        theme: 'colored',
                    });
                }).catch((error) => {
                    setIsUnpublishing(false);
                    toast.error('Failed to unpublish the report', {
                        position: 'top-right',
                        autoClose: false,
                        transition: Slide,
                        draggable: false,
                        closeOnClick: false,
                        theme: 'colored',
                    });
                });
            }}
            data-testid="unpublishReport">

            {isUnpublishing ? (
                <Spinner size="sm" className="button-icon-padding button-spinner" animation="border" />
            ) : (
                <DocumentSubtract size={24} className="button-icon-padding" title="Unpublish Report" />
            )}
            Unpublish Report
        </Button>
    ) : null;
}
export default ReportUnpublishButton;